import {
  GET_STAFF_REQUEST,
  GET_STAFF_SUCCESS,
  GET_STAFF_FAIL,
  DELETE_STAFF_REQUEST,
  DELETE_STAFF_SUCCESS,
  DELETE_STAFF_FAIL,
  STAFF_DETAILS_REQUEST,
  STAFF_DETAILS_SUCCESS,
  STAFF_DETAILS_FAIL,
  CREATE_STAFF_REQUEST,
  CREATE_STAFF_SUCCESS,
  CREATE_STAFF_FAIL,
  EDIT_STAFF_REQUEST,
  EDIT_STAFF_SUCCESS,
  EDIT_STAFF_FAIL,
} from "./actionTypes";

export const getStaffRequest = () => ({
  type: GET_STAFF_REQUEST,
});

export const getStaffSuccess = Staffs => ({
  type: GET_STAFF_SUCCESS,
  payload: Staffs,
});

export const getStaffFail = error => ({
  type: GET_STAFF_FAIL,
  payload: error,
});

export const deleteStaffRequest = Staff => ({
  type: DELETE_STAFF_REQUEST,
  payload: Staff,
});

export const deleteStaffSuccess = Staff => ({
  type: DELETE_STAFF_SUCCESS,
  payload: Staff,
});

export const deleteStaffFail = error => ({
  type: DELETE_STAFF_FAIL,
  payload: error,
});
export const getStaffDetailRequest = email => ({
  type: STAFF_DETAILS_REQUEST,
  payload: email,
});

export const getStaffDetailSuccess = Staff => ({
  type: STAFF_DETAILS_SUCCESS,
  payload: Staff,
});

export const getStaffDetailFail = error => ({
  type: STAFF_DETAILS_FAIL,
  payload: error,
});

export const createStaffRequest = Staff => {
  return {
    type: CREATE_STAFF_REQUEST,
    payload: Staff,
  };
};

export const createStaffSuccess = Staff => {
  return {
    type: CREATE_STAFF_SUCCESS,
    payload: Staff,
  };
};

export const createStaffFail = error => {
  return {
    type: CREATE_STAFF_FAIL,
    payload: error,
  };
};

export const editStaffRequest = (Staff, email) => {
  return {
    type: EDIT_STAFF_REQUEST,
    payload: { Staff, email },
  };
};
export const editStaffSuccess = Staff => ({
  type: EDIT_STAFF_SUCCESS,
  payload: Staff,
});

export const editStaffFail = error => ({
  type: EDIT_STAFF_FAIL,
  payload: error,
});
